import React, { useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box } from '@mui/material';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";

function Past90DaysData() {
  const [data, setData] = useState([]);
  const [past90DaysData, setPast90DaysData] = useState([]);
  const [past90DaysTotal, setPast90DaysTotal] = useState(0);
  const userEmail = localStorage.getItem('UserEmail') || '';
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${accessToken}` },
      body: JSON.stringify({ userEmail })
    })
      .then(response => response.json())
      .then(data => {
        
        const approvedData = data.filter(item => item.ApplicationStatus === 'APPROVED');
        setData(approvedData);
        
        const past90Days = new Date();
        past90Days.setDate(past90Days.getDate() - 90);
        
        const filteredData = approvedData.filter(item => {
          const itemDate = new Date(item.startingdate.replace(/-/g, '/'));
          return itemDate >= past90Days && itemDate <= new Date();
        });
        
        setPast90DaysData(filteredData);
        setPast90DaysTotal(filteredData.reduce((total, item) => total + item.noofdays, 0));
      })
      .catch(error => console.error("Error fetching data:", error));
  }, [userEmail]);

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'leavetype', headerName: 'Leave Type', flex: 1 },
    { field: 'startingdate', headerName: 'Start Date', flex: 1 },
    { field: 'endingdate', headerName: 'End Date', flex: 1 },
    { field: 'ApplyingDate', headerName: 'Apply Date', flex: 1 },
    { field: 'ApplicationStatus', headerName: 'Status', flex: 1 },
    { field: 'noofdays', headerName: 'No Of Days', flex: 1 },
  ];

  const past90DaysRows = past90DaysData.map(item => ({
    id: item.applicationno, // Ensure this is unique
    leavetype: item.leavetype,
    startingdate: item.startingdate,
    endingdate: item.endingdate,
    ApplyingDate: item.ApplyingDate,
    ApplicationStatus: item.ApplicationStatus,
    noofdays: item.noofdays,
  }));

  return (
    <Box m="20px">
      <Header title="PAST 90 DAYS DATA" />
      <Box m="40px 0 0 0" height="75vh" sx={{
        "& .MuiDataGrid-root": { border: "none" },
        "& .MuiDataGrid-cell": { borderBottom: "none" },
        "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
        "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
        "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
        "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": { color: `${colors.grey[100]} !important` },
      }}>
        <h2>Past 90 Days Total: {past90DaysTotal}</h2>
        <DataGrid 
          rows={past90DaysRows} 
          columns={columns} 
          components={{ Toolbar: GridToolbar }}
          pagination
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          checkboxSelection
          autoHeight
          hideFooterSelectedRowCount
        />
      </Box>
    </Box>
  );
}

export default Past90DaysData;